module.exports = __webpack_public_path__ + "img/playbutton19.3bd2af40.png";